import { InvestmentAllocation, InvestmentEntity } from '../../models/InvestmentEntity';
import InvestmentEntityContact from '../../models/InvestmentEntityContact';

export interface EntityManagementState {
  entity: InvestmentEntity | null;
  contacts: InvestmentEntityContact[];
  allocations: InvestmentAllocation[];
  loading: boolean;
  error: string | null;
  isEditing: boolean;
  editedEntity: {
    name: string;
    description: string;
    isForeignInvestor: boolean;
  };
  showContactAssociation: boolean;
  expandedSections: {
    contacts: boolean;
    allocations: boolean;
  };
  showActivityLog: boolean;
}

export const initialEntityManagementState: EntityManagementState = {
  entity: null,
  contacts: [],
  allocations: [],
  loading: true,
  error: null,
  isEditing: false,
  editedEntity: {
    name: '',
    description: '',
    isForeignInvestor: false,
  },
  showContactAssociation: false,
  expandedSections: {
    contacts: true,
    allocations: false,
  },
  showActivityLog: false,
};
